
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[…notFound]",
      function () {
        return require("private-next-pages/[…notFound].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[…notFound]"])
      });
    }
  